import { Link } from "react-router-dom";
import { homepageData } from "@/mocks/homepage";

export default function MembershipSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {homepageData.membership.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            {homepageData.membership.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {homepageData.membership.plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl p-6 md:p-8 transition-all duration-300 ${
                plan.highlighted
                  ? "bg-primary-500 text-white border-2 border-primary-500 scale-[1.02]"
                  : "bg-background-50 border border-background-200/70 hover:border-primary-300"
              }`}
            >
              {plan.highlighted && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-500 text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                  最受欢迎
                </div>
              )}
              <h3 className={`text-lg font-semibold mb-2 ${plan.highlighted ? "text-white" : "text-foreground-900"}`}>
                {plan.name}
              </h3>
              <div className="flex items-baseline gap-1 mb-6">
                <span className={`text-3xl md:text-4xl font-bold ${plan.highlighted ? "text-white" : "text-foreground-950"}`}>
                  ¥{plan.price}
                </span>
                <span className={`text-sm ${plan.highlighted ? "text-white/70" : "text-foreground-500"}`}>
                  /{plan.period}
                </span>
              </div>
              <ul className="flex flex-col gap-3 mb-8">
                {plan.features.map((f) => (
                  <li key={f} className={`flex items-center gap-2 text-sm ${plan.highlighted ? "text-white/90" : "text-foreground-600"}`}>
                    <i className={`ri-check-line w-4 h-4 flex items-center justify-center ${plan.highlighted ? "text-white" : "text-primary-500"}`}></i>
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                to="/about"
                className={`block text-center py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap ${
                  plan.highlighted
                    ? "bg-white text-primary-500 hover:bg-white/90"
                    : "bg-primary-500 text-white hover:bg-primary-600"
                }`}
              >
                立即开通
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}